module.exports = __webpack_public_path__ + "img/revenue.86ddb32.svg";